// unit: filter3
import Operator from "./Operator";


const Contain = Operator.extend("Ilike", {
    literal: ["ilike"],

    validateValue(value) {
        return this.validateLiteral(value);
    },

    compile2js(left, right) {
        if ( right == null ) {
            right = ".*";
        }

        right = right + "";
        right = right.toLowerCase();
        right = JSON.stringify(right);
        right = right.replace(/%/g, ".*");
        right = right.replace(/_/g, ".");

        // _lowercase @see RowModel.parse2filter
        return "( " + left + " && " + left + "._lowerCase || (" + left + " + '').toLowerCase() ).search( new RegExp( " + right + ", 'i' ) ) !== -1";
    }
});

export default Contain;
